export const ROUTE = {
  HOME: "/",
  DESTINATION: "/destination",
  SERVICE: "/service",
  ABOUT_US: "/about-us",
  CONTACT_US: "/contact-us",
  UNSUBSCRIBE: "/unsubscribe",
}